import React, { useState, useEffect } from "react";
import Header from "../Components/ProductLeadReport/Header";
import ProductLeadReportOverview from "../Components/ProductLeadReport/ProductLeadReportOverview";
import { getProductLeadReport } from "../actions/ProductLeadReportAction";
import { getProductLeadReports } from "../services/productLeadReport";
import { getDistributorNames } from "../Common/functions";

const ProductLeadReport = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  function getTotalPages(totalItems, itemsPerPage) {
    if (itemsPerPage <= 0) return 0; // avoid division by zero
    return Math.ceil(totalItems / itemsPerPage);
  }

  const getApplicationReport1 = async () => {
    setData([]);
    setLoading(true);

    try {
      const result = await getProductLeadReports({
        category: "sales tracking",
        tracking_status: "Lead",
        page_size: itemsPerPage,
        page_number: currentPage,
        start_date: filters.fromDate,
        end_date: filters.toDate,
        distributor_name: getDistributorNames()[0],
        search_term: searchTerm,
      });

      if (result?.data) {
        setData(result.data.items);
        setCurrentPage(result.data.current_page);
        setTotalCount(result.data.total_records);
        setTotalPages(getTotalPages(result.data.total_records, itemsPerPage));
      } else {
        console.error("Unexpected response format:", result);
      }
    } catch (error) {
      console.error("Error fetching product lead reports:", error);
    } finally {
      setLoading(false); // Ensure loading state is reset
    }
  };

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      getApplicationReport1();
    }
  }, [searchTerm]);

  useEffect(() => {
    getApplicationReport1();
  }, [itemsPerPage, currentPage, filters]);

  return (
    <div className="space-y-10">
      <Header />
      <ProductLeadReportOverview
        data={data}
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        setCurrentPage={setCurrentPage}
        setSearchTerm={setSearchTerm}
        setFilters={setFilters}
        setItemsPerPage={setItemsPerPage}
        itemsPerPage={itemsPerPage}
      />
    </div>
  );
};

export default ProductLeadReport;
